import { forwardRef } from "react";

import { cx, styled } from "simplydo/react/styled";
import { computerUp, mobileOnly, tabletOnly } from "simplydo/react/theme";

import type { GridColumnProps } from "./Grid.types";

const StyledGridColumn = styled.div<{
  $span: number;
  $computer?: number;
  $tablet?: number;
  $mobile?: number;
  $stretched?: boolean;
}>`
  display: flex;
  flex-direction: column;

  position: relative;
  box-sizing: border-box;
  min-width: 0;
  grid-column: span ${({ $span }) => $span};
  align-self: ${({ $stretched }) => ($stretched ? "stretch" : "auto")};

  ${mobileOnly} {
    &.is-mobile {
      grid-column: span ${({ $mobile, $span }) => $mobile ?? $span};
    }
  }

  ${tabletOnly} {
    &.is-tablet {
      grid-column: span ${({ $tablet, $span }) => $tablet ?? $span};
    }
  }

  ${computerUp} {
    &.is-computer {
      grid-column: span ${({ $computer, $span }) => $computer ?? $span};
    }
  }
`;

const GridColumnComponent = forwardRef<HTMLDivElement, GridColumnProps>(
  (props, ref) => {
    const {
      span = 1,
      computer,
      tablet,
      mobile,
      children,
      className,
      style,
      stretched,
      ...rest
    } = props;
    return (
      <StyledGridColumn
        ref={ref}
        className={cx(
          mobile != null && "is-mobile",
          tablet != null && "is-tablet",
          computer != null && "is-computer",
          className,
        )}
        style={style}
        $span={span}
        $computer={computer}
        $tablet={tablet}
        $mobile={mobile}
        $stretched={stretched}
        {...rest}
      >
        {children}
      </StyledGridColumn>
    );
  },
);

GridColumnComponent.displayName = "GridColumn";

export const GridColumn = styled(GridColumnComponent)``;
